<template>
  <div class="loadingDiv">
    <van-loading size="24px" vertical type="spinner">校验订单中...</van-loading>
  </div>
</template>

<script>
import { findOrder } from '../api/api.js'
import { Toast } from 'vant'
export default {
  components: {},
  props: {},
  data () {
    return {
      timeFlag: '',
      index: 0,
      iccid: ''
    }
  },
  computed: {},
  methods: {
    async setTimeFn (order) {
      const that = this
      that.timeFlag = ''
      if (that.index < 6) {
        const { data: resss } = await findOrder({
          payId: order
        })
        if (!resss) return Toast('支付失败')
        if (resss && resss.result) {
          that.index++
          that.timeFlag = resss.result
          if (that.timeFlag === 'SUCCESS') {
            this.$store.commit('setType', 'success')
            this.$router.push({ name: 'Recharge', params: { iccid: this.$store.state.iccd } })
            Toast.success('支付成功')
          } else {
            that.setTimeFn(this.$store.state.order)
          }
        }
      } else {
        this.$store.commit('setFlag', 'false')
        this.$store.commit('setType', 'recharge')
        this.$router.push({ name: 'Recharge', params: { iccid: this.$store.state.iccd } })
      }
    }
  },
  beforeCreate () {},
  created () {
    this.iccid = this.$store.state.iccd
    const order = this.$store.state.order
    this.setTimeFn(order)
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .loadingDiv {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -70%)
  }
</style>
